export default [{
  label: 'Include',
  id: 'any'
}, {
  label: 'Exclude',
  id: 'false'
}, {
  label: 'Only',
  id: 'true'
}];